"use strict";
var carbucks = carbucks || {};
const pricelist = document.getElementById("js-pricelist");
const titles = document.querySelectorAll(".js-pricelist-item-title");
const images = document.querySelectorAll(".js-pricelist-image");
let activeItem = document.querySelector(
  ".js-pricelist-item.part-pricelist-list-item--open"
);
let activeImage = document.querySelector(
  ".js-pricelist-image.part-pricelist-image--visible"
);

carbucks.pricelist =
  carbucks.pricelist ||
  (function() {
    function init() {
      if (pricelist && titles) {
        clickOnMobile();
        for (let i = 0; i < titles.length; i++) {
          const currentTitle = titles[i];
          currentTitle.addEventListener("click", function(e) {
            closeAll();
            const clickedTitle = e.currentTarget;
            const clickedParent = clickedTitle.parentNode;
            const clickedContent = clickedParent.querySelector('.js-pricelist-item-content');
            const clickedId = clickedParent.dataset.id;
            const matchingImage = document.querySelector(
              '.js-pricelist-image[data-id="' + clickedId + '"]'
            );
            matchingImage.classList.add("part-pricelist-image--visible");
            clickedParent.classList.add("part-pricelist-list-item--open");

            activeImage = matchingImage;
            activeItem = clickedParent;
          });
        }
      }
    }

    function clickOnMobile() {
      if (window.innerWidth < 992) {
        for (let i = 0; i < images.length; i++) {
          const current = images[i];

          current.addEventListener("click", function(e) {
            let clickedItem = e.currentTarget;
            clickedItem.classList.toggle("part-pricelist-image--active");
          });
        }
      }
    }

    function closeAll() {
      activeItem.classList.remove("part-pricelist-list-item--open");
      activeImage.classList.remove("part-pricelist-image--visible");
    }
    return {
      init: init,
    };
  })();
